function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { filterMentionItems, getMentionQuery, insertMentionValue, resolveMentionValue } from '../../../lib/proposalMentions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var autoResizeTextarea = function autoResizeTextarea(el) {
  if (!el || el.tagName !== 'TEXTAREA') return;
  // rows>1 forces a tall intrinsic height even for one line of text — measure from 1 row
  var prevRows = el.rows;
  el.rows = 1;
  el.style.height = 'auto';
  var next = "".concat(Math.max(el.scrollHeight, 1), "px");
  el.style.height = next;
  el.rows = prevRows || 1;
};
var readTypographyKey = function readTypographyKey(el, value, rows) {
  if (!el) return '';
  var cs = window.getComputedStyle(el);
  return [value, rows, el.offsetWidth, cs.fontSize, cs.lineHeight, cs.fontFamily, cs.fontWeight, cs.letterSpacing, cs.paddingTop, cs.paddingBottom, cs.borderTopWidth, cs.borderBottomWidth].join('|');
};

/**
 * Mirror the input/textarea to measure caret (x,y) relative to the element.
 * Used so the @-mention menu opens next to the typed "@", not at the field corner.
 */
var getCaretCoordinates = function getCaretCoordinates(element, position) {
  if (!element || typeof position !== 'number') {
    return {
      top: 0,
      left: 0,
      height: 16
    };
  }
  var computed = window.getComputedStyle(element);
  var isInput = element.tagName === 'INPUT';
  var div = document.createElement('div');
  var mirrorStyles = ['direction', 'boxSizing', 'width', 'height', 'borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'fontStyle', 'fontVariant', 'fontWeight', 'fontStretch', 'fontSize', 'fontSizeAdjust', 'lineHeight', 'fontFamily', 'textAlign', 'textTransform', 'textIndent', 'textDecoration', 'letterSpacing', 'wordSpacing', 'tabSize', 'MozTabSize', 'whiteSpace', 'wordBreak', 'overflowWrap', 'wordWrap'];
  div.setAttribute('data-mention-caret-mirror', 'true');
  mirrorStyles.forEach(function (prop) {
    div.style[prop] = computed[prop];
  });
  div.style.position = 'absolute';
  div.style.top = '0';
  div.style.left = '-9999px';
  div.style.visibility = 'hidden';
  div.style.whiteSpace = isInput ? 'pre' : computed.whiteSpace || 'pre-wrap';
  div.style.overflowWrap = computed.overflowWrap || 'anywhere';
  div.style.wordBreak = computed.wordBreak || 'break-word';
  div.style.overflow = 'hidden';
  div.style.width = "".concat(element.offsetWidth, "px");
  var value = element.value || '';
  var textBefore = value.substring(0, position);
  div.textContent = textBefore;
  var marker = document.createElement('span');
  marker.textContent = value.substring(position) || '.';
  div.appendChild(marker);
  document.body.appendChild(div);
  var lineHeight = Number.parseFloat(computed.lineHeight);
  var caretHeight = Number.isFinite(lineHeight) && lineHeight > 0 ? lineHeight : marker.offsetHeight || Number.parseFloat(computed.fontSize) || 16;
  var coordinates = {
    top: marker.offsetTop - element.scrollTop,
    left: marker.offsetLeft - element.scrollLeft,
    height: caretHeight
  };
  document.body.removeChild(div);
  return coordinates;
};
var MENU_WIDTH = 260;
var MENU_MAX_HEIGHT = 240;
var clampMenuPosition = function clampMenuPosition(_ref) {
  var top = _ref.top,
    left = _ref.left;
  var maxLeft = Math.max(8, window.innerWidth - MENU_WIDTH - 8);
  var maxTop = Math.max(8, window.innerHeight - MENU_MAX_HEIGHT - 8);
  return {
    top: Math.max(8, Math.min(top, maxTop)),
    left: Math.max(8, Math.min(left, maxLeft))
  };
};
export default function MentionAwareInput(_ref2) {
  var value = _ref2.value,
    onChange = _ref2.onChange,
    onFocusSelect = _ref2.onFocusSelect,
    _ref2$style = _ref2.style,
    style = _ref2$style === void 0 ? {} : _ref2$style,
    _ref2$placeholder = _ref2.placeholder,
    placeholder = _ref2$placeholder === void 0 ? 'Type here...' : _ref2$placeholder,
    _ref2$isTextArea = _ref2.isTextArea,
    isTextArea = _ref2$isTextArea === void 0 ? false : _ref2$isTextArea,
    _ref2$singleLine = _ref2.singleLine,
    singleLine = _ref2$singleLine === void 0 ? false : _ref2$singleLine,
    _ref2$rows = _ref2.rows,
    rows = _ref2$rows === void 0 ? 3 : _ref2$rows,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'default' : _ref2$variant,
    _ref2$mentionConfig = _ref2.mentionConfig,
    mentionConfig = _ref2$mentionConfig === void 0 ? null : _ref2$mentionConfig;
  var isOnColor = variant === 'onColor';
  var useTextArea = !singleLine;
  // Shrink-wrap chip/button labels so canvas matches preview (avoid default ~20ch input/textarea).
  var fitContent = isOnColor || singleLine;
  var inputRef = useRef(null);
  var menuRef = useRef(null);
  var typographyKeyRef = useRef('');
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    mentionState = _useState2[0],
    setMentionState = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    activeIndex = _useState4[0],
    setActiveIndex = _useState4[1];
  var _useState5 = useState({
      top: 0,
      left: 0
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    menuPos = _useState6[0],
    setMenuPos = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    resolving = _useState8[0],
    setResolving = _useState8[1];
  var mentionItems = (mentionConfig === null || mentionConfig === void 0 ? void 0 : mentionConfig.items) || [];
  var filteredItems = mentionState ? filterMentionItems(mentionItems, mentionState.query) : [];

  // Grow with text + font-size/line-height changes (inherited from block), without
  // collapsing height on unrelated parent re-renders (selection thrash).
  useLayoutEffect(function () {
    if (!useTextArea) return;
    var el = inputRef.current;
    if (!el) return;
    var key = readTypographyKey(el, value, rows);
    if (key === typographyKeyRef.current) return;
    typographyKeyRef.current = key;
    autoResizeTextarea(el);
  });
  useEffect(function () {
    if (!useTextArea) return undefined;
    var el = inputRef.current;
    if (!el) return undefined;
    var lastWidth = el.offsetWidth;
    var ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(function () {
      if (!inputRef.current) return;
      var width = inputRef.current.offsetWidth;
      if (width === lastWidth) return;
      lastWidth = width;
      typographyKeyRef.current = '';
      autoResizeTextarea(inputRef.current);
    }) : null;
    if (ro) ro.observe(el);
    return function () {
      if (ro) ro.disconnect();
    };
  }, [useTextArea]);
  var wrapStyle = {
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
    wordBreak: 'normal'
  };

  // Button / chip labels must shrink to text (like preview <a>), not stretch to
  // the browser default textarea cols / input size (~20ch).
  var contentLength = Math.max(String(value || placeholder || ' ').length, fitContent ? 4 : 1);
  var commonStyle = _objectSpread(_objectSpread(_objectSpread({
    border: 'none',
    background: 'transparent',
    width: fitContent ? 'auto' : '100%',
    minWidth: fitContent ? '4ch' : 0,
    maxWidth: '100%'
  }, fitContent ? {
    fieldSizing: 'content'
  } : {}), {}, {
    // At least one full line at current font-size so descenders aren't clipped
    minHeight: '1.25em',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    color: 'inherit',
    letterSpacing: 'inherit',
    lineHeight: 'inherit',
    textAlign: 'inherit',
    textTransform: 'inherit',
    padding: 0,
    margin: '0',
    borderRadius: isOnColor ? '0' : '4px',
    outline: 'none',
    boxSizing: 'border-box',
    resize: 'none',
    overflow: 'hidden',
    display: fitContent ? 'inline-block' : 'block'
  }, wrapStyle), style);
  var Component = useTextArea ? 'textarea' : 'input';
  var applyFocusStyle = function applyFocusStyle(target) {
    if (isOnColor) {
      target.style.outline = '1px dashed rgba(255, 255, 255, 0.55)';
      target.style.outlineOffset = '0';
      return;
    }
    target.style.background = 'transparent';
    target.style.boxShadow = 'inset 0 0 0 1.5px #94a3b8';
  };
  var clearFocusStyle = function clearFocusStyle(target) {
    if (isOnColor) {
      target.style.outline = 'none';
      target.style.outlineOffset = '';
      return;
    }
    target.style.background = 'transparent';
    target.style.boxShadow = 'none';
  };
  var applyHoverStyle = function applyHoverStyle(target) {
    if (document.activeElement === target) return;
    target.style.background = isOnColor ? 'rgba(255, 255, 255, 0.08)' : 'rgba(15, 23, 42, 0.04)';
  };
  var updateMenuPosition = function updateMenuPosition(el, caretIndex) {
    var _el$selectionStart, _menuRef$current;
    if (!el) return;
    var rect = el.getBoundingClientRect();
    var caretPos = typeof caretIndex === 'number' ? caretIndex : (_el$selectionStart = el.selectionStart) !== null && _el$selectionStart !== void 0 ? _el$selectionStart : (el.value || '').length;
    var caret = getCaretCoordinates(el, caretPos);
    var preferredTop = rect.top + caret.top + caret.height + 6;
    var preferredLeft = rect.left + caret.left;
    var menuHeight = ((_menuRef$current = menuRef.current) === null || _menuRef$current === void 0 ? void 0 : _menuRef$current.offsetHeight) || MENU_MAX_HEIGHT;

    // If not enough room below, open above the caret line
    var openAbove = preferredTop + menuHeight > window.innerHeight - 8;
    var top = openAbove ? rect.top + caret.top - menuHeight - 6 : preferredTop;
    setMenuPos(clampMenuPosition({
      top: top,
      left: preferredLeft
    }));
  };
  var syncMentionFromInput = function syncMentionFromInput(el, nextValue) {
    var _el$selectionStart2, _mention$end;
    if (!mentionConfig || !el) {
      setMentionState(null);
      return;
    }
    var cursor = (_el$selectionStart2 = el.selectionStart) !== null && _el$selectionStart2 !== void 0 ? _el$selectionStart2 : (nextValue || '').length;
    var mention = getMentionQuery(nextValue || '', cursor);
    if (!mention) {
      setMentionState(null);
      return;
    }
    setMentionState(mention);
    setActiveIndex(0);
    updateMenuPosition(el, (_mention$end = mention.end) !== null && _mention$end !== void 0 ? _mention$end : cursor);
  };
  var handleChange = function handleChange(e) {
    if (useTextArea) {
      autoResizeTextarea(e.target);
    }
    var nextValue = e.target.value;
    if (typeof onChange === 'function') {
      onChange(nextValue);
    }
    syncMentionFromInput(e.target, nextValue);
  };
  var selectMention = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(item) {
      var el, resolveValue, insertValue, nextValue;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!mentionState || !item || resolving)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            el = inputRef.current;
            if (el) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return");
          case 5:
            setResolving(true);
            _context.prev = 6;
            resolveValue = (mentionConfig === null || mentionConfig === void 0 ? void 0 : mentionConfig.resolveMentionValue) || resolveMentionValue;
            _context.next = 10;
            return resolveValue({
              mode: (mentionConfig === null || mentionConfig === void 0 ? void 0 : mentionConfig.mode) || 'template',
              documentId: (mentionConfig === null || mentionConfig === void 0 ? void 0 : mentionConfig.documentId) || null,
              key: item.key,
              label: item.label
            });
          case 10:
            insertValue = _context.sent;
            nextValue = insertMentionValue(value || '', mentionState.start, mentionState.end, insertValue);
            if (typeof onChange === 'function') {
              onChange(nextValue);
            }
            setMentionState(null);
            requestAnimationFrame(function () {
              if (!inputRef.current) return;
              var cursor = mentionState.start + insertValue.length;
              inputRef.current.focus();
              inputRef.current.setSelectionRange(cursor, cursor);
              if (useTextArea) {
                autoResizeTextarea(inputRef.current);
              }
            });
          case 15:
            _context.prev = 15;
            setResolving(false);
            return _context.finish(15);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[6,, 15, 18]]);
    }));
    return function selectMention(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (!mentionState) return undefined;
    var handleClickOutside = function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target) && inputRef.current && !inputRef.current.contains(event.target)) {
        setMentionState(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      return document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [mentionState]);

  // Keep menu glued to caret while scrolling/resizing
  useLayoutEffect(function () {
    if (!mentionState) return undefined;
    var el = inputRef.current;
    if (!el) return undefined;
    var reposition = function reposition() {
      return updateMenuPosition(el, mentionState.end);
    };
    reposition();
    window.addEventListener('resize', reposition);
    // Capture scroll from canvas / nested scroll parents
    window.addEventListener('scroll', reposition, true);
    return function () {
      window.removeEventListener('resize', reposition);
      window.removeEventListener('scroll', reposition, true);
    };
  }, [mentionState, value]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Component, {
      type: useTextArea ? undefined : 'text',
      value: value || '',
      rows: useTextArea ? 1 : undefined,
      cols: useTextArea && fitContent ? contentLength : undefined,
      size: !useTextArea && fitContent ? contentLength : undefined,
      placeholder: placeholder,
      ref: inputRef,
      onChange: handleChange,
      onInput: useTextArea ? function (e) {
        return autoResizeTextarea(e.target);
      } : undefined,
      onClick: function onClick(e) {
        e.stopPropagation();
        syncMentionFromInput(e.target, e.target.value);
      },
      onMouseDown: function onMouseDown(e) {
        return e.stopPropagation();
      },
      onKeyDown: function onKeyDown(e) {
        if (mentionState && filteredItems.length > 0) {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            setActiveIndex(function (prev) {
              return (prev + 1) % filteredItems.length;
            });
            return;
          }
          if (e.key === 'ArrowUp') {
            e.preventDefault();
            setActiveIndex(function (prev) {
              return (prev - 1 + filteredItems.length) % filteredItems.length;
            });
            return;
          }
          if (e.key === 'Enter' || e.key === 'Tab') {
            e.preventDefault();
            selectMention(filteredItems[activeIndex]);
            return;
          }
          if (e.key === 'Escape') {
            e.preventDefault();
            setMentionState(null);
            return;
          }
        }
        if (!useTextArea && e.key === 'Enter') {
          e.target.blur();
        }
      },
      onKeyUp: function onKeyUp(e) {
        syncMentionFromInput(e.target, e.target.value);
      },
      style: commonStyle,
      onFocus: function onFocus(e) {
        if (typeof onFocusSelect === 'function') {
          onFocusSelect();
        }
        if (useTextArea) {
          autoResizeTextarea(e.target);
        }
        applyFocusStyle(e.target);
      },
      onBlur: function onBlur(e) {
        clearFocusStyle(e.target);
      },
      onMouseEnter: function onMouseEnter(e) {
        applyHoverStyle(e.target);
      },
      onMouseLeave: function onMouseLeave(e) {
        if (document.activeElement !== e.target) {
          clearFocusStyle(e.target);
          if (!isOnColor) {
            e.target.style.background = 'transparent';
          }
        }
      }
    }), mentionState && filteredItems.length > 0 && typeof document !== 'undefined' && /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/_jsxs("div", {
      ref: menuRef,
      "data-mention-dropdown": "true",
      style: {
        position: 'fixed',
        top: menuPos.top,
        left: menuPos.left,
        zIndex: 999999,
        minWidth: 220,
        maxWidth: MENU_WIDTH,
        maxHeight: MENU_MAX_HEIGHT,
        overflowY: 'auto',
        background: '#fff',
        border: '1px solid #E4E7EC',
        borderRadius: 8,
        boxShadow: '0 10px 25px rgba(15, 23, 42, 0.14)'
      },
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
        e.stopPropagation();
      },
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          padding: '8px 12px 4px',
          fontSize: 11,
          fontWeight: 600,
          color: '#94a3b8'
        },
        children: (mentionConfig === null || mentionConfig === void 0 ? void 0 : mentionConfig.mode) === 'design' ? 'Insert data' : 'Insert variable'
      }), filteredItems.map(function (item, index) {
        return /*#__PURE__*/_jsxs("button", {
          type: "button",
          onClick: function onClick(e) {
            e.stopPropagation();
            selectMention(item);
          },
          style: {
            display: 'block',
            width: '100%',
            textAlign: 'left',
            border: 'none',
            background: index === activeIndex ? '#f1f5f9' : 'transparent',
            padding: '9px 12px',
            cursor: resolving ? 'wait' : 'pointer',
            fontFamily: 'DM Sans, sans-serif',
            fontSize: 13,
            color: '#0f172a'
          },
          children: [/*#__PURE__*/_jsx("div", {
            style: {
              fontWeight: 600
            },
            children: item.label
          }), /*#__PURE__*/_jsx("div", {
            style: {
              fontSize: 11,
              color: '#64748b',
              marginTop: 2
            },
            children: (mentionConfig === null || mentionConfig === void 0 ? void 0 : mentionConfig.mode) === 'design' ? 'Real value' : "{{".concat(item.key, "}}")
          })]
        }, item.key);
      })]
    }), document.body)]
  });
}